/**
 * @description 文件预览
 * @param {Object} data 文件数据,包含相对路径 {filePath: ''}
 */
export const getPreviewFile = data => {
  if (!data || !data.url) {
    return
  }
  const fn = url => {
    if (!url) {
      return false
    }
    const a = document.createElement('a')
    a.href = url
    a.download = true
    a.target = '_blank'
    a.click()
    a.remove()
  }
  fn(data.url)
  return true
}
// 通过后缀判断是否是图片链接
export const imgReg = new RegExp(
  '^.*.(bmp|jpg|png|tif|gif|pcx|tga|exif|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|ai|raw|wmp|webp|jpeg|heic)$'
)
export const emailReg = /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/

// 数值计算
export const accuracy = {
  division(arg1, arg2) {
    //除法
    var t1 = 0,
      t2 = 0,
      r1,
      r2
    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {
      console.log(e)
    }
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {
      console.log(e)
    }
    if (Math) {
      r1 = Number(arg1.toString().replace('.', ''))
      r2 = Number(arg2.toString().replace('.', ''))
      return this.multiply(r1 / r2, Math.pow(10, t2 - t1))
    }
  },
  multiply(arg1, arg2) {
    //乘法
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {
      console.log(e)
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
      console.log(e)
    }
    return (
      (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
      Math.pow(10, m)
    )
  },
  add(arg1, arg2) {
    //加法
    var r1, r2, m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (this.multiply(arg1, m) + this.multiply(arg2, m)) / m
  },
  subtract(arg1, arg2) {
    //减法
    var r1, r2, m, n
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    n = r1 >= r2 ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  // 计算一个数组的总和
  sum(arr) {
    let result = 0
    arr.forEach(item => {
      result = this.add(result, item)
    })
    return result
  },
  // 计算一个数组的总和 fn是对每项数据的处理方式
  sumBy(arr, fn) {
    let result = 0
    arr.forEach(item => {
      let val = item
      if (fn) {
        val = fn(item)
      }
      result = this.add(result, val)
    })
    return result
  },
  toCeil(num, p = 4) {
    num = isNaN(num) ? 0 : num
    p = isNaN(p) ? 0 : p
    let precision = Math.pow(10, p)
    return Math.ceil((num * precision).toFixed(1)) / precision
  },
  toFloor(num, p = 4) {
    num = isNaN(num) ? 0 : num
    p = isNaN(p) ? 0 : p
    let precision = Math.pow(10, p)
    return Math.floor((num * precision).toFixed(1)) / precision
  }
}

/** 金钱格式化 显示两位小数 四舍五入保留或补齐0
 * @param {String | Number} num 需要被格式化的值
 * @returns {String} 格式化之后的值
 */

export const moneyFormat = num => {
  if (!num || isNaN(num)) {
    return '0.00'
  }
  num = Number(num).toFixed(2)
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
